import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  AppBar,
  Toolbar,
  IconButton,
  CircularProgress,
  Grid,
  Paper,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import CloseIcon from "@mui/icons-material/Close";
import Webcam from "react-webcam";
import QrReader from "react-web-qr-reader";
import { toast } from "react-toastify";
import WaitingLoader from "../../WaitingLoader/component";
import TagpayIcon from "../../assets/tagpay.png";
import Tagkey from "../../assets/tagkey.png";

const TagAdd = (props) => {
  const [showScanner, setShowScanner] = useState(false);
  const [cameraFacingMode, setCameraFacingMode] = useState("environment");
  const inputRefs = useRef([]);

  const handleOtpChange = (value, index) => {
    if (!/^\d*$/.test(value)) return;
    const otpArray = props.secretkey.split("");
    otpArray[index] = value;
    const newOtp = otpArray.join("");
    props.handleChangeSecretkey(newOtp);
    if (value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !props.secretkey[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleScan = (result) => {
    if (result?.data) {
      props.setTokenNumber(result.data);
      setShowScanner(false);
    }
  };

  const handleError = (error) => {
    toast.error(`${error}`, { position: "top-right", autoClose: 1000 });
  };

  // Header Component
const Header = ({ title, onBack }) => (
  <>
    <AppBar position="fixed" sx={{ backgroundColor: "#fae14b", color: "#000" }}>
      <Toolbar sx={{ display: "flex", alignItems: "center" }}>
        <IconButton edge="start" color="inherit" onClick={onBack} sx={{ mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>

        <Typography
          variant="h6"
          sx={{ fontWeight: 600, flexGrow: 1, display: "flex", alignItems: "center" }}
        >
          {title}
        </Typography>

        {/* Placeholder to balance the arrow */}
        <Box width="40px" />
      </Toolbar>
    </AppBar>

    {/* Spacer so content starts below the fixed header */}
    <Toolbar />
  </>
);

  return (
    <>
      {props.loader && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
          <WaitingLoader />
        </Box>
      )}

      {/* QR SCANNER VIEW */}
      {showScanner && (
        <Box sx={{ position: "relative", height: "100vh", bgcolor: "#000" }}>
          <AppBar position="static" sx={{ bgcolor: "#fae14b", color: "#000" }}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={() => setShowScanner(false)}>
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Scan Tag
              </Typography>
            </Toolbar>
          </AppBar>

          <Webcam
            videoConstraints={{ facingMode: cameraFacingMode }}
            className="object-cover"
            style={{ width: "100%", height: "100vh", objectFit: "cover" }}
          />

          <Box
            sx={{
              border: "4px solid #fae14b",
              borderRadius: "16px",
              width: 220,
              height: 220,
              position: "absolute",
              top: "35%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <QrReader
              delay={50}
              onError={handleError}
              onScan={handleScan}
              facingMode={cameraFacingMode}
              style={{ width: "100%", height: "100%" }}
            />
          </Box>
        </Box>
      )}

      {/* STEP 1: ENTER TAG */}
      {!showScanner && props.pageCount === 1 && (
        <Box>
          <Header title="Add Tag" onBack={() => window.history.back()} />

          <Grid
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{
              height: "calc(100vh - 64px)",
             
            }}
          >
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3, textAlign: "center", width: "400px",background:"none" ,boxShadow:"none"}}>
              <div style={{    display:"flex",justifyContent: "center"}}><img src={TagpayIcon} alt="TagPay" style={{ width: 120, marginBottom: 20 }} /></div>
              <Typography variant="h6" gutterBottom fontWeight="bold">
                Enter Tag Number
              </Typography>

              <TextField
                variant="outlined"
                placeholder="Enter Tag Number"
                value={props.tokenNumber}
                onChange={props.handleChangeRfIDToken}
                fullWidth
                sx={{ mt: 2, mb: 3 }}
              />

              <Button
                variant="contained"
                onClick={props.SearchToken}
                fullWidth
                sx={{
                  backgroundColor: "rgb(0, 177, 119)",
                  color: "#fff",
                  borderRadius: "10px",
                  py: 1.5,
                  fontSize: "16px",
                  fontWeight: 600,
                  "&:hover": { backgroundColor: "#2b3c56" },
                }}
              >
                Submit
              </Button>

              <Typography sx={{ mt: 4 }}>Or</Typography>
              <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
                Scan QR Code to Add New Tag
              </Typography>

              <IconButton
                color="primary"
                size="large"
                onClick={() => setShowScanner(true)}
                sx={{
                  bgcolor: "#fae14b",
                  borderRadius: "50%",
                  width: 80,
                  height: 80,
                  "&:hover": { bgcolor: "#fadc3d" },
                }}
              >
                <QrCodeScannerIcon sx={{ fontSize: 40, color: "#000" }} />
              </IconButton>
            </Paper>
          </Grid>
        </Box>
      )}

      {/* STEP 2: ENTER SECRET KEY */}
      {props.pageCount === 2 && (
        <Box>
          <Header title="Link TagPay" onBack={() => window.history.back()} />

          <Box
            sx={{
              height: "calc(100vh - 64px)",
              background:
                "radial-gradient(circle, rgba(245,233,233,0.4) 0%, rgba(185,245,247,0.34) 100%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <img src={Tagkey} alt="Tag Key" style={{ width: 100, height: 100, marginBottom: 20 }} />
            <Typography variant="h6" fontWeight={700} color="#384F6F">
              Enter Secret Code
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
              Your tag secret is printed on the tag holder
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
              {Array(6)
                .fill("")
                .map((_, index) => (
                  <TextField
                    key={index}
                    inputRef={(el) => (inputRefs.current[index] = el)}
                    value={props.secretkey[index] || ""}
                    onChange={(e) => handleOtpChange(e.target.value, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    inputProps={{
                      maxLength: 1,
                      style: {
                        textAlign: "center",
                        fontSize: 22,
                        width: "15px",
                        height: "15px",
                      },
                    }}
                    sx={{ mx: 1 }}
                  />
                ))}
            </Box>

            <Typography variant="caption" sx={{ mb: 2, color: "#666" }}>
              By linking your TagPay, you agree to Terms & Conditions.
            </Typography>

            <Button
              variant="contained"
              onClick={props.secretkey.length === 6 ? props.SubmitSecretKeyActive : undefined}
              disabled={props.secretkey.length !== 6}
              sx={{
                width: "80%",
                mt: 2,
                py: 1.2,
                borderRadius: "12px",
                backgroundColor: props.secretkey.length === 6 ? "rgb(0, 177, 119)" : "#ccc",
                color: "#fff",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: props.secretkey.length === 6 ? "rgb(0, 177, 119)" : "#ccc",
                },
              }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};

export default TagAdd;
